import { z } from 'zod';

import { MemberRole } from './member.schema';

export const MemberFormSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be less than 100 characters'),
  addr: z
    .string()
    .min(1, 'Wallet address is required')
    .regex(/^0x[a-fA-F0-9]{40}$/, 'Invalid wallet address format'),
  role: z.nativeEnum(MemberRole, {
    errorMap: () => ({ message: 'Please select a valid role' }),
  }),
});

export type MemberFormInputs = z.infer<typeof MemberFormSchema>;
